<app-web-navbar></app-web-navbar>
<div class="shipping-container">
  <h1 class="mb-1">Shipping and Delivery </h1>
  <div class="decorator mb-4"></div>
      
  <p> Shipping is not applicable for business.</p>
</div>

<app-web-footer></app-web-footer>